// extracted by mini-css-extract-plugin
export var container = "parking-detail-info-table-module--container---aPS0";
export var infoRow = "parking-detail-info-table-module--infoRow--22Kyi";
export var infoKeySection = "parking-detail-info-table-module--infoKeySection--34pDF";
export var infoValueSection = "parking-detail-info-table-module--infoValueSection--1Knli";
export var addressText = "parking-detail-info-table-module--addressText--3ZxyT";
export var feesRow = "parking-detail-info-table-module--feesRow--1y1B3";
export var feesText = "parking-detail-info-table-module--feesText--NFj5r";
export var servicesText = "parking-detail-info-table-module--servicesText--3Fn2h";
export var openGoogleMapButton = "parking-detail-info-table-module--openGoogleMapButton--1q-qi";
export var copyAddressButton = "parking-detail-info-table-module--copyAddressButton--3G2Y5";
export var downloadQtNetButton = "parking-detail-info-table-module--downloadQtNetButton--2boPe";